var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.666748H6V2.00008H10V0.666748Z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6867 4.92675L13.6333 3.98008C13.3467 3.64008 13.0333 3.32008 12.6933 3.04008L11.7467 3.98675C10.7133 3.16008 9.41333 2.66675 8 2.66675C4.68667 2.66675 2 5.35341 2 8.66675C2 11.9801 4.68 14.6667 8 14.6667C11.32 14.6667 14 11.9801 14 8.66675C14 7.25341 13.5067 5.95341 12.6867 4.92675ZM8.66667 9.33341H7.33333V5.33341H8.66667V9.33341Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon_time.c86f4b66435c80073dbecf48410cea97.svg";
export { ForwardRef as ReactComponent };